<template>
  <div class="blogDetails">
    <app-BlogDetails :blogId="blogId"></app-BlogDetails>
  </div>
</template>

<script>
import blogDetails from "../components/blog/blogDetails";
export default {
  name: "blogDetails",
  props: ["blogId"],
  components: {
    appBlogDetails: blogDetails
  }
};
</script>
